import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createMatchSelector } from 'connected-react-router';
import { compose, path, pipe, applySpec } from 'ramda';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import {
  isEntry,
  getTachyReportLoadingById,
  getLastUpdated,
  getPatientId,
  getDocumentId,
} from 'store/selectors/tachyReport';
import { isResearcher, isDoctor, getUserId } from 'store/selectors/user';
import withPageLoader from 'components/withPageLoader';
import { FORM_NAMES } from 'constants/forms';
import { requestGetTachyReport } from 'store/actionCreators/newTachyReport';
import TachyReport from 'components/TachyReport/TachyReport';
import validate from './validate';

const mapStateToProps = applySpec({
  id: getDocumentId,
  patientId: getPatientId,
  lastUpdated: getLastUpdated,
  isTachyReport: isEntry,
  isResearcher,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps),
  withRouter,
  withPageLoader({
    loadingSelector: (
      state,
      {
        match: {
          params: { id },
        },
      },
    ) => getTachyReportLoadingById(id)(state),
    initialActionArgsSelector: applySpec({
      id: pipe(
        createMatchSelector('/patient/:id'),
        path(['params', 'id']),
      ),
      author: getUserId,
      isDoctor,
      isResearcher,
    }),
    initialAction: requestGetTachyReport,
  }),
  reduxForm({
    form: FORM_NAMES.uploadTachyReport,
    validate,
  }),
)(TachyReport);
